import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    EXTERNAL_URL
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: commonUtilBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const studentCommonAPI = createApi({
    reducerPath: "studentCommonAPI",
    baseQuery: commonUtilBaseQuery,
    endpoints: (builder) => ({
        getInstituteDropdown: builder.query({
            query: (params) => ({
                url: `/util/student/dropdown`,
                method: "GET",
                params,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    }),
});

export const {
    useGetInstituteDropdownQuery
} = studentCommonAPI;

export default studentCommonAPI;
